import { useCoordinatorOptions, useSorTemplateOptions, useBrandOptions } from "../../../../../query/hooks/QueryHooksVersionDetails";

/**
 * Loads the Version Details form's Qualification Co-ordinator / SOR Template /
 * Override Brand option lists, each React Query-backed (cached, deduped, no
 * manual cancel-token/isMounted bookkeeping).
 */
function useVersionDetailsOptions() {
    const { options: coordinatorOptions, isLoading: isCoordinatorLoading } = useCoordinatorOptions();
    const { options: sorTemplateOptions } = useSorTemplateOptions();
    const { options: brandOptions } = useBrandOptions();

    return { coordinatorOptions, isCoordinatorLoading, sorTemplateOptions, brandOptions };
}

export default useVersionDetailsOptions;
